import Vue from 'vue';
var Highcharts = require('highcharts');

export default Vue.extend({
  props: {
    series: {
      type: Object,
      required: true,
    },
  },
  data () {
    return {
      categories: [],
      chartData: [],
    };
  },
  created () {
    this.chartData = [];
    this.chartData = this.series;
  },
  mounted () {
    this.renderChart();
  },
  methods: {
    renderChart () {
      const self = this;

      this.chart = Highcharts.chart(this.$el, {
        chart: {
          type: 'pie',
          height: 450,
          minHeight: 450,
        },
        title: {
          text: '',
        },
        subtitle: {
          text: '',
        },
        plotOptions: {
          pie: {
            shadow: false,
            center: ['60%', '50%'],
            cursor: 'pointer',
            animation: 'cubic-bezier(0.25, 0.46, 0.45, 0.94)',
            showInLegend: true,
          },
        },
        style: {
          fontSize: '16px',
        },
        legend: {
          itemStyle: {
            color: '#000000',
            fontWeight: '300',
            fontSize: '16px',
            fontFamily: '\'Roboto\', sans-serif',
          },
          width: 150,
          floating: true,
          layout: 'vertical',
          x: '-100%',
          y: 0,
        },
        tooltip: {
          backgroundColor: 'none',
          borderColor: 'none',
          borderRadius: 0,
          borderWidth: 0,
          headerFormat: '',
          positioner: function (boxWidth, boxHeight, point) {
            return { x: point.plotX - 10, y: point.plotY - 35 };
          },
          pointFormat: '<div class="qa-result__tooltip"><div>{point.name}</div><div>{point.y}</div></div>',
          useHTML: true,
          shared: true,
        },
        series: [{
          data: self.chartData.inside,
          size: '55%',
          dataLabels: {
            enabled: false,
            formatter: function () {
              return this.y > 5 ? this.point.name : null;
            },
            color: '#ffffff',
            distance: -30,
            style: {
              fontSize: '12px',
              textTransform: 'uppercase',
            },
          },
        }, {
          data: self.chartData.outside,
          size: '100%',
          innerSize: '60%',
          dataLabels: {
            enabled: false,
            formatter: function () {
              return this.y > 1 ? '<b>' + this.point.name + ':</b> ' +
                                this.y + '%' : null;
            },
            style: {
              fontSize: '16px',
              fontWeight: 'normal',
            },
          },
        }],
        exporting: {
          enabled: false,
        },
        responsive: {
          rules: [{
            condition: {
              maxWidth: 400,
            },
            chartOptions: {
              series: [{
                id: 'versions',
                dataLabels: {
                  enabled: false,
                },
              }],
            },
          }],
        },
      });
    },
  },
  beforeDestroy() {
    if (this.chart) {
      this.chart.destroy();
    }
  },
});
